const initialState = {
  location: undefined
};

export default function routing(state = initialState, action = {}) {
  switch (action.type) {
    case '@@router/UPDATE_LOCATION':
      return {
        ...state,
        location: action.payload
      };

    default:
      return state;
  }
}
